<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'
import { notify } from '@/helpers/notify'

export default {
  page: {
    title: "Taksitliler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable
  },
  mixins: [ datatableMixin],
  data() {
    return {
        title: "TAKSİTLİLER",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "TAKSİTLİLER",
          active: true,
        }],

        searchParams: {},
        sort: { column: 'upcoming_due_date', order: 'asc' },
        columns: [
            { name: '', key: 'action', orderable: false },
          { name: 'Kullanıcı Adı', key: 'username', orderable: true },
          { name: 'İsim Soyisim', key: 'fullname' },
          { name: 'Kalan Taksit', key: 'remaining_count', className: 'text-end', orderable: true },
          { name: 'Kalan Taksit Tutarı', key: 'remaining_amount', className: 'text-end', orderable: true },
          { name: 'Yaklaşan Taksit Tarihi', key: 'upcoming_due_date', className: 'text-end', orderable: true }
        ],
        tableData: {
          detail: false,
          excel: false,
          searchable:{
            visible:true,
            placeholder:"İsim Soyisim ve Kullanıcı adı Ara"
          }
        },
        endpoint: '/reports/taksitliler',
        showDetailsModal: false,
        detailLoading: false,
        installmentDetails: [],
    };
  },
  computed: {
    isAdmin(){ try{ const u = JSON.parse(localStorage.getItem('userdata'))||{}; return u.role_name === 'admin'; }catch(e){ return false } }
  },
  methods: {

    async loadPage() {
      this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true

      const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
      if (this.params.page === 1) {
          this.tableData.data = response.data.data;
      } else {
          this.tableData.data = [...this.tableData.data, ...response.data.data];
      }

      this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
      this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
    },
    iptal(props){
        this.$http.post('/taksit-iptal', { id:props.id })
        .then(() => this.loadPage())
    },
    async showDetails(row){
      this.installmentDetails = [];
      this.showDetailsModal = true;
      this.detailLoading = true;
      try{
        const res = await this.$http.get(`/members/${row.id}/getInstallments`, { params: { all: 1 } });
        const data = res.data || res;
        // handle different shapes
        if(data.details) this.installmentDetails = data.details;
        else if(data.installments) this.installmentDetails = data.installments;
        else if(Array.isArray(data)) this.installmentDetails = data;
        else if(data.rows) this.installmentDetails = data.rows;
        // normalize date field for inputs
        this.installmentDetails = this.installmentDetails.map(d => {
          const copy = Object.assign({}, d);
          if(copy.due_date){
            // ensure YYYY-MM-DD for input
            copy.due_date_simple = copy.due_date.substr(0,10);
          } else {
            copy.due_date_simple = '';
          }
          return copy;
        });
      }catch(e){
        this.installmentDetails = [];
      }finally{
        this.detailLoading = false;
      }
    },

    async saveInstallment(d){
      if(!this.isAdmin) return notify.error('Yetkiniz yok');
      if(!d.active) return notify.error('Eski taksit planı güncellenemez');
      const subId = this.installmentDetails && this.installmentDetails.length ? this.installmentDetails[0].subscription_id : null;
      if(!subId) return notify.error('Abone bilgisi bulunamadı');
      const payload = { due_date: d.due_date_simple, status: d.status };
      try{
        await this.$http.put(`/members/${subId}/installment/${d.id}`, payload);
        notify.success('Güncellendi');
        // refresh details
        this.showDetails({ id: subId });
      }catch(err){
        notify.error('Güncelleme hatası');
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Datatable
        :columns="columns"
        :tableData="tableData"
        :sort="sort"
        @sort-column="handleSortColumn"
        @search-query="reLoadPage"
        @excel-export="excelExport"
        :loading="isLoading"
        :poading="pageLoading">

          <template #fullname="{ row }">
              {{ row.fname }} {{ row.lname }}
          </template>
             <template #remaining_count="{ row }">
              {{ row.remaining_count }}
            </template>
            <template #remaining_amount="{ row }">
              {{ row.remaining_amount }}
            </template>
             <template #upcoming_due_date="{ row }">
               {{ row.upcoming_due_date ? formatDate(row.upcoming_due_date, 'DD.MM.YYYY') : '' }}
            </template>

         <template #action="{ row }">
              <b-dropdown
                  toggle-class="font-size-16 p-0"
                  toggle-tag="a"
                  variant="white"
                  append-to-body
                  >
                  <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                    <b-dropdown-item @click="showDetails(row)">Taksit Detayları</b-dropdown-item>
                    <b-dropdown-item @click="iptal(row)">Takstin Tümünü İptal Et</b-dropdown-item>
              </b-dropdown>
          </template>

     </Datatable>
    <b-modal v-model="showDetailsModal" size="lg" title="Taksit Detayları" hide-footer>
      <div v-if="detailLoading" class="text-center py-4">
        <b-spinner small type="grow"></b-spinner>
      </div>
      <div v-else>
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Plan</th>
              <th>Taksit No</th>
              <th>Tutar</th>
              <th>Durum</th>
              <th>Vade</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, idx) in installmentDetails" :key="idx" :class="{ 'table-success': d.active && (d.status === 'paid' || d.paid_at), 'table-warning': d.active && d.status === 'pending', 'text-muted': !d.active }">
              <td>{{ d.active ? 'Aktif' : 'Eski' }}</td>
              <td>{{ d.installment_no || d.num || d.installment }}</td>
              <td>{{ d.amount || d.price }}</td>
                <td>
                  <div v-if="isAdmin && d.active">
                    <select class="form-select form-select-sm" v-model="d.status">
                      <option value="pending">Beklemede</option>
                      <option value="paid">Ödendi</option>
                    </select>
                  </div>
                  <div v-else>
                    {{ d.status ? (d.status == 'paid' ? 'Ödendi' : (d.status == 'pending' ? 'Beklemede' : d.status)) : (d.paid_at ? 'Ödendi' : 'Beklemede') }}
                  </div>
                </td>
              <td>
                <div v-if="isAdmin && d.active" class="d-flex">
                  <input type="date" class="form-control form-control-sm me-2" v-model="d.due_date_simple" />
                  <button class="btn btn-sm btn-primary" @click="saveInstallment(d)">Kaydet</button>
                </div>
                <div v-else>
                  {{ d.due_date ? formatDate(d.due_date, 'DD.MM.YYYY') : '' }}
                </div>
              </td>
            </tr>
            <tr v-if="installmentDetails.length === 0">
              <td colspan="6" class="text-center">Detay bulunamadı.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </Layout>
</template>